module.exports = __webpack_public_path__ + "img/IMG_2493_L_Black.2fe0fdbe.jpg";